import { jwtDecode } from 'jwt-decode';
import { JWTUser } from '../db/userTypes';

export function decodeAPITokenJWT<T extends JWTUser = JWTUser>(token: string | null): T | null {
  if (!token) {
    return null;
  }

  try {
    return jwtDecode<T>(token);
  } catch (error) {
    console.log(error);
    return null;
  }
}
